define(
({
  "select_shipping_method": "選擇貨運方式"
})
);
